module.exports = __webpack_public_path__ + "assets/5a167f194970686480e7679cc032ce6e.mp3";